module.exports = __webpack_public_path__ + "static/media/product-screen-4.60f78f8a.png";